import { createSlice } from "@reduxjs/toolkit";
import { SpedDevolutionState } from "./types";

const INITIAL_STATE: SpedDevolutionState = {
  singleFile: null,
  error: null,
  processedFile: null,
  processingMessage: null,
};

const spedDevolutionSlice = createSlice({
  name: "spedDevolution",
  initialState: INITIAL_STATE,
  reducers: {
    setSingleFile(state, action) {
      state.singleFile = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setProcessedFile(state, action) {
      state.processedFile = action.payload;
    },
    setProcessingMessage(state, action) {
      state.processingMessage = action.payload;
    },
    clearFiles(state) {
      state.singleFile = null;
    },
  },
});

export const {
  setSingleFile,
  setError,
  setProcessedFile,
  clearFiles,
} = spedDevolutionSlice.actions;

export default spedDevolutionSlice.reducer;
